import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.match";
import "core-js/modules/web.timers";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useRef, useEffect } from 'react';
import useSettings from '../hooks/use-core-settings';

var getElement = function getElement(_ref) {
  var level = _ref.level,
      el = _ref.el;
  return el.match(/^h[1-6]$/) ? {
    el: "h".concat(level)
  } : {
    el: el,
    elementProps: {
      'role': 'heading',
      'aria-level': level
    }
  };
};

var Heading = function Heading(_ref2) {
  var _ref2$el = _ref2.el,
      el = _ref2$el === void 0 ? 'h1' : _ref2$el,
      _ref2$level = _ref2.level,
      level = _ref2$level === void 0 ? 1 : _ref2$level,
      _ref2$focusOnMount = _ref2.focusOnMount,
      focusOnMount = _ref2$focusOnMount === void 0 ? false : _ref2$focusOnMount,
      _ref2$delay = _ref2.delay,
      delay = _ref2$delay === void 0 ? 500 : _ref2$delay,
      headingRef = _ref2.headingRef,
      className = _ref2.className,
      children = _ref2.children,
      keepProps = _objectWithoutProperties(_ref2, ["el", "level", "focusOnMount", "delay", "headingRef", "className", "children"]);

  var _useSettings = useSettings(),
      pageHasFocus = _useSettings.pageHasFocus;

  var viewFocusComplete = useRef(false);
  useEffect(function () {
    var timeout;

    if (!viewFocusComplete.current && !pageHasFocus && focusOnMount) {
      timeout = setTimeout(function () {
        headingRef.current.focus();
      }, delay);
    }

    viewFocusComplete.current = true;
    return function () {
      return clearTimeout(timeout);
    };
  }, [delay, focusOnMount, headingRef, pageHasFocus]);

  var _getElement = getElement({
    level: level,
    el: el
  }),
      Element = _getElement.el,
      _getElement$elementPr = _getElement.elementProps,
      elementProps = _getElement$elementPr === void 0 ? {} : _getElement$elementPr;

  return /*#__PURE__*/React.createElement(Element, _extends({}, elementProps, keepProps, {
    ref: headingRef,
    tabIndex: "-1",
    className: className
  }), children);
};

export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Heading, _extends({}, props, {
    headingRef: ref || /*#__PURE__*/React.createRef()
  }));
});